import { OrkiszewskiFlowRegime } from ".";
import { GRAVITY_FT_SEC } from "../../constants";
import type { PipeFrictionContext } from "../d";
import type { PipeFrictionIntermediates } from "..";

export function calculateGradientsBubble(
  tubingFrictionContext: PipeFrictionContext
): PipeFrictionIntermediates {
  const {
    fluidPropertiesContext: {
      fluidProperties: {
        liquidDensityLBMFT3,
        liquidViscosityCP,
        gasDensityLBMFT3,
        liquidSuperficialVelocityFTSEC,
        mixSuperficialVelocityFTSEC,
        gasSuperficialVelocityFTSEC
      },
      fluidFrictionProperties: {
        bubbleRiseVelocity,
        hydraulicDiameterFt,
        noSlipLiquidHoldupLambdaCL
      }
    },
    epsilonD,
    pipeLengthFt,
    griffithWallis
  } = tubingFrictionContext;

  const includeGriffithWallis = griffithWallis || false;
  let liquidHoldup = noSlipLiquidHoldupLambdaCL;
  if (includeGriffithWallis) {
    liquidHoldup =
      1 -
      0.5 *
        (1 +
          mixSuperficialVelocityFTSEC / 0.24384 -
          Math.sqrt(
            (1 + mixSuperficialVelocityFTSEC / 0.24384) ** 2 -
              (4 * gasSuperficialVelocityFTSEC) / 0.24384
          ));
  }

  // TODO: WHERE DO THESE GO?
  // COMMON VARIABLES REFACTORED OUT OF REGIMES
  // D191: =(D130^D220)
  // const mixtureViscosityUM = liquidViscosityCP ** liquidHoldup;

  // D222: =D63*D220+D62*(1-D220)
  // D245: =D63*D220+D62*(1-D220)
  const mixtureDensityPM =
    liquidDensityLBMFT3 * liquidHoldup + gasDensityLBMFT3 * (1 - liquidHoldup);

  // D226: =D155/D220
  // D251: =D155/D220
  const inSituLiquidVelocityVL = liquidSuperficialVelocityFTSEC / liquidHoldup;

  // D248: =1488*D175*D136*D63/D130
  const reynoldsTwoPhaseNumber_Re =
    (1488 * bubbleRiseVelocity * hydraulicDiameterFt * liquidDensityLBMFT3) /
    liquidViscosityCP;

  // D254: =(1/(-2*LOG10(D228/3.7065-(5.0452/D224)*LOG10(((D228^1.1098)/2.8257)+(5.8506/(D224^0.8981))))))^2
  const chenFriction =
    (1 /
      (-2 *
        Math.log10(
          epsilonD / 3.7065 -
            (5.0452 / reynoldsTwoPhaseNumber_Re) *
              Math.log10(
                epsilonD ** 1.1098 / 2.8257 +
                  5.8506 / reynoldsTwoPhaseNumber_Re ** 0.8981
              )
        ))) **
    2;

  // D258: =((D230*D226^2)/(2*D67*D136))
  const frictionGradient =
    (2 * chenFriction * inSituLiquidVelocityVL ** 2) /
    (144 * GRAVITY_FT_SEC * hydraulicDiameterFt);

  // D260: =(D222/144)*D3*SIN(D8)
  // const hydrostaticPressurePSIA = (mixtureDensityPM / 144) * hydrostaticSum;

  // D262: =D234*D3
  const frictionPressurePSIA = frictionGradient * pipeLengthFt;

  return {
    flowRegime: OrkiszewskiFlowRegime.BUBBLE,
    frictionPressurePSIA,
    includeGriffithWallis,
    liquidHoldup,
    mixtureDensityPM,
    inSituLiquidVelocityVL,
    frictionGradient,
    reynoldsTwoPhaseNumber_Re,
    chenFriction
  };
}
